<template>
 <div class="finance-reports-production">
    <div class="finance-reports-production__filters d-flex align-items-center my-3">
      <datepicker
        id="selectedStartDate"
        v-model="selectedStartDate"
        :startDate="minDateForSelect"
        :endDate="maxDateForSelect"
      >
      </datepicker>
      <datepicker
        id="selectedEndDate"
        v-model="selectedEndDate"
        :startDate="minDateForSelect"
        :endDate="maxDateForSelect"
        class="ml-2"
      >
      </datepicker>
      <select class="form-control custom-select ml-2" v-if="isDirector" v-model="selectedManagerId" id="managerId">
        <option v-for="manager in managers" :key="manager.name" :value="manager.id" :selected="manager.id === selectedManagerId">{{ manager.name }}</option>
      </select>
      <autocomplete id="clientName" class="ml-2" :suggestions="clientNames" :selectionText.sync="clientName" :selectionId.sync="clientId"></autocomplete>
      <button @click="loadReport" class="btn btn-primary mx-3">Применить</button>
    </div>
    <div class="finance-reports-production__report text-center my-5">
      <div class="finance-reports-production__report-row d-flex">
        <div class="finance-reports-production__report-column d-flex flex-column w-50">
          <h5 class="my-3">Отчет за период</h5>
          <div class="finance-reports-production__report-row d-flex w-100 h-100">
            <div class="finance-reports-production__report-block finance-reports-production__report-block--green rounded d-flex flex-column align-items-center justify-content-center w-50">
              <span class="pt-3">Сумма выполненных закрытых заказов</span>
              <span class="py-3">{{totalExecuteCloseTasks}}</span>
            </div>
            <div class="finance-reports-production__report-block finance-reports-production__report-block--red rounded d-flex flex-column align-items-center justify-content-center w-50 ml-2">
              <span class="pt-3">Сумма неоплаченных выполненных закрытых заказов</span>
              <span class="py-3">{{totalUnpaidExecuteCloseTasks}}</span>
            </div>
          </div>
        </div>
        <div class="finance-reports-production__report-column d-flex flex-column w-50">
          <h5 class="my-3 w-50 pl-5">Отчет на сегодня</h5>
          <div class="finance-reports-production__report-row d-flex pl-5 w-100">
            <div class="finance-reports-production__report-block finance-reports-production__report-block--blue rounded d-flex flex-column align-items-center w-50">
              <span class="pt-3">Сумма заказов в работе</span>
              <span class="py-3">{{totalTaskInWork}}</span>
            </div>
          </div>
          <div class="finance-reports-production__report-row d-flex mt-2 pl-5 w-100">
            <div class="finance-reports-production__report-block finance-reports-production__report-block--orange rounded d-flex flex-column align-items-center w-50">
              <span class="pt-3">Сумма неоплаченных заказов в работе</span>
              <span class="py-3">{{totalUnpaidTasksInWork}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../../api'
import moment from 'moment'
import roles from '../../../../helpers/userRoles'
import datepicker from '../../../../components/datepicker.vue'
import autocomplete from '../../../../components/autocoplete.vue'
const today = new Date()
const firstDateOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
const demoFirstDate = new Date(2021, 0, 1)
const isDemo = location.host.indexOf('demo') >= 0
const maxDate = new Date(new Date().setDate(today.getDate() + 1))
const minDate = new Date(0)

const formatNumber = (num) => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
}

export default {
  name: 'FinanceReportsMenagers',
  components: { datepicker, autocomplete },
  data () {
    return {
      users: [],
      maxDateForSelect: maxDate,
      minDateForSelect: minDate,
      selectedStartDate: isDemo ? demoFirstDate : firstDateOfMonth,
      selectedEndDate: today,
      clientName: '',
      clientId: -1,
      clients: [],
      companies: [],
      selectedManagerId: null,
      totalTaskInWork: null,
      totalExecuteCloseTasks: null,
      totalUnpaidTasksInWork: null,
      totalUnpaidExecuteCloseTasks: null
    }
  },
  computed: {
    clientNames () {
      let result = [{ value: -1, text: 'Все клиенты', search: 'всеклиенты' }]
      result = result.concat(this.clients.filter(x => !x.legal_entity)
        .map(x => { return { value: x.id, text: x.name, search: `${x.name}${x.email}${x.telephone}`.toLowerCase().replace(/[^a-zA-Zа-яА-Я0-9]+/g, '') } }), this.companies.map(x => { return { value: x.id, text: x.name, search: `${x.name}${x.email}${x.telephone}`.toLowerCase().replace(/[^a-zA-Zа-яА-Я0-9]+/g, '') } }))
      return result
    },
    selectedClientId () {
      const result = this.clients.find(x => x.id === this.clientId)
      if (result) {
        return result.id
      }
      return undefined
    },
    selectedCompanyId () {
      const result = this.companies.find(x => x.id === this.clientId)
      if (result) {
        return result.id
      }
      return undefined
    },
    managers () {
      const result = [{ id: null, name: 'Все менеджеры' }]
      const userForSelect = this.users.filter(
        x => x.roles === roles.director || x.roles === roles.manager
      )

      userForSelect.forEach(user => {
        result.push({ id: user.id, name: `${user.firstname} ${user.lastname}` })
      })

      return result
    },
    isDirector () {
      return this.$store.getters.role === roles.director
    },
    isCanLoadReport () {
      return this.selectedStartDate && this.selectedEndDate && moment(this.selectedStartDate, 'DD-MM-YYYY') <= moment(this.selectedEndDate, 'DD-MM-YYYY')
    },
    date () {
      return moment(this.startDate, 'DD-MM-YYYY').format('DD-MM-YYYY')
    }
  },
  created () {
    Promise.all([this.loadUsers(), this.loadClients(), this.loadCompanies()])
  },
  methods: {
    async loadUsers () {
      try {
        const response = await api.get.users()
        this.users = response.data.data.users.filter(x => x.enabled)
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    async loadClients () {
      try {
        const response = await api.get.clients()
        this.clients = response.data.data.clients
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    async loadCompanies () {
      try {
        const response = await api.get.companies()
        this.companies = response.data.data.legalEntities
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    async loadReport () {
      const filter = {
        start_date: moment(this.selectedStartDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
        end_date: moment(this.selectedEndDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
        client: this.selectedClientId,
        company: this.selectedCompanyId,
        manager: this.selectedManagerId === null ? undefined : this.selectedManagerId
      }
      try {
        const response = await api.post.reportProduction(filter)
        const data = response.data.data
        this.totalTaskInWork = formatNumber(data.totalTaskInWork.toFixed(2))
        this.totalExecuteCloseTasks = formatNumber(data.totalExecuteCloseTasks.toFixed(2))
        this.totalUnpaidTasksInWork = formatNumber(data.totalUnpaidTasksInWork.toFixed(2))
        this.totalUnpaidExecuteCloseTasks = formatNumber(data.totalUnpaidExecuteCloseTasks.toFixed(2))
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.finance-reports-production {
  &__filters{
    .form-control{
      max-width: 250px;
    }
  }

  &__report-block {
    &--green {
      color: #28bd8b;
      background-color: lighten($color: #28bd8b, $amount: 40);
    }
     &--blue {
      color: #408fc2;
      background-color: lighten($color: #408fc2, $amount: 40);
    }
    &--orange {
      color: #e08e3c;
      background-color: lighten($color: #e08e3c, $amount: 40);
    }
    &--gray {
      color: #7b7c7d;
      background-color: lighten($color: #7b7c7d, $amount: 40);
    }
    &--red {
      color: #e84c3d;
      background-color: lighten($color: #e84c3d, $amount: 40);
    }
  }
}
</style>
